import { YodaColors } from 'yoda-ui/yodaTheme';

export const CssTextField = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-disabled': {
      backgroundColor: YodaColors.gray0,
    },
  },
};
